import {Injectable} from '@angular/core';
import {PlanModelService} from '../../common/service/plan-model.service';
import {from, map, Observable, of} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({
    providedIn: 'root'
})
export class SpatialQueryService {
    title = 'Spatial Query Service';

    constructor(private planModelService: PlanModelService) {}

    queryFeatures(featureLayer: any, whereClause?: string, options: {start?: number; allFeatures?: any[]} = {}): Observable<any[]> {
        const query = new (window as any).esri.tasks.Query();
        query.start = options.start || 0;
        query.num = 1000;
        query.where = whereClause || '1=1';
        query.outFields = ['*'];
        query.outSpatialReference = new (window as any).esri.SpatialReference(this.planModelService.getSpatialReference());

        return from(featureLayer.queryFeatures(query)).pipe(
            switchMap((res: any) => {
                const features = res.features || [];
                const allFeatures = options.allFeatures || [];
                allFeatures.push(...features);

                // If there are more features to fetch, recurse; otherwise, return all features
                if (features.length === query.num) {
                    return this.queryFeatures(featureLayer, whereClause, {start: query.start + query.num, allFeatures});
                } else {
                    console.debug(`${this.title} - queryFeatures() success`);
                    return of(allFeatures); // Use 'of' to return an observable of the accumulated results
                }
            }),
            catchError(err => {
                console.error(`${this.title} - queryFeatures() error: ${err} ${whereClause} ${featureLayer}`);
                throw err; // Re-throw error to be handled by the observable chain
            })
        );
    }

    queryObjectIds(featureLayer: any, whereClause: string): Observable<number[]> {
        console.debug(`${this.title} - queryObjectIds(), featureType:${featureLayer}, whereClause: ${whereClause}`);

        const query = new (window as any).esri.tasks.Query();
        query.where = whereClause || '1=1';

        return from(featureLayer.queryIds(query)).pipe(
            map((objectIds: number[]) => {
                console.debug(`${this.title} - queryObjectIds() success`);
                return objectIds || [];
            }),
            catchError(err => {
                console.error(`${this.title} - queryObjectIds() error: ${err}`);
                throw err; // Re-throw to handle error in the observable chain
            })
        );
    }
}
